export const QA_NAME_CALENDAR_GRID_BODY_MESSAGE_ACTION =
  'calendarGridBodyMessageAction'

export const QA_NAME_CALENDAR_GRID_BODY_MESSAGE = 'calendarGridBodyMessage'
